import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import SegmentedControllerItem from './SegmentedControllerItem/SegmentedControllerItem';
import { SegmentedControllerContext } from './context';
import styles from './SegmentedController.module.scss';
const SegmentedController = ({ className, initialValue, value, label, onValueChange, children, size = 'small', }) => {
    const isControlled = value !== undefined;
    const [internalValue, setInternalValue] = useState(initialValue);
    const currentValue = isControlled ? value : internalValue;
    const handleValueChange = useCallback((newValue) => {
        if (!isControlled) {
            setInternalValue(newValue);
        }
        if (onValueChange) {
            onValueChange(newValue);
        }
    }, [onValueChange, isControlled]);
    const contextValue = useMemo(() => ({
        selectedValue: currentValue,
        handleValueChange,
        size,
    }), [currentValue, handleValueChange, size]);
    return (React.createElement("div", { className: cx(styles.wrapper, className) },
        label && React.createElement("label", { className: styles.label }, label),
        React.createElement("div", { className: cx(styles.controlContainer), role: "group", "aria-label": label },
            React.createElement(SegmentedControllerContext.Provider, { value: contextValue }, children))));
};
SegmentedController.Item = SegmentedControllerItem;
export default SegmentedController;
